
export default {
  orsDictionary: {
    unknown: 'Unknown',
    paved: 'Paved',
    unpaved: 'Unpaved',
    asphalt: 'Asphalt',
    concrete: 'Concrete',
    cobblestone: 'Cobblestone',
    metal: 'Metal',
    wood: 'Wood',
    compactedGravel: 'Compacted Gravel',
    fineGravel: 'Fine Gravel',
    gravel: 'Gravel',
    dirt: 'Dirt',
    ground: 'Ground',
    ice: 'Ice',
    pavingStones: 'Paving Stones',
    sand: 'Sand',
    woodchips: 'Woodchips',
    grass: 'Grass',
    grassPaver: 'Grass Paver',
    none: 'None',
    no: 'No',
    customers: 'Customers',
    destination: 'Destination',
    delivery: 'Delivery',
    private: 'Private',
    permissive: 'Permissive',
    permit: 'Permit',
    stateRoad: 'State Road',
    road: 'Road',
    street: 'Street',
    path: 'Path',
    track: 'Track',
    cycleway: 'Cycleway',
    footway: 'Footway',
    steps: 'Steps',
    ferry: 'Ferry',
    construction: 'Construction',
    'concrete:lanes': 'concrete lanes',
    paving_stones: 'paving stones',
    sett: 'Sett',
    unhewn_cobblestone: 'Unhewn cobblestone',
    compacted: 'Compacted',
    fine_gravel: 'Fine gravel',
    pebblestone: 'Pebblestone',
    impassable: 'Impassable',
    very_horrible: 'Very horrible',
    horrible: 'Horrible',
    very_bad: 'Very bad',
    bad: 'Bad',
    intermediate: 'Intermediate',
    good: 'Good',
    excellent: 'Excellent',
    grade1: 'Grade 1',
    grade2: 'Grade 2',
    grade3: 'Grade 3',
    grade4: 'Grade 4',
    grade5: 'Grade 5',

    no_tollway: 'No tollway',
    is_tollway: 'Is tollway',
    no_category: 'No category',
    highway: 'Highway',
    unpaved_road: 'Unpaved road',
    tunnel:	'Tunnel',
    paved_road:	'Paved road',
    ford: 'Ford',
    no_data: 'No data',
    low: 'Low',
    moderate: 'Moderate',
    high: 'High'
  }
}
